import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod, makeDataMethod } from "../core/base-api/methods-maker";
import { MeLikesApi } from "./me/likes-api";
import { MeNotificationsApi } from "./me/notifications-api";
import { MePlaylistsApi } from "./me/playlists-api";
import { MeProfileApi } from "./me/profile-api";
import { MeWatchLaterApi } from "./me/watch-later-api";
import { MeCommunityApi } from "./me/community-api";
import { MeFacebookApi } from "./me/facebook-api";
import { MeInterestsApi } from "./me/interests-api";
import { MePointSystemApi } from "./me/point-system-api";
export var MeApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(MeApi, _BaseApi);

  var _super = _createSuper(MeApi);

  function MeApi(config) {
    var _this;

    _classCallCheck(this, MeApi);

    _this = _super.call(this, config);
    _this.likes = void 0;
    _this.notifications = void 0;
    _this.playlists = void 0;
    _this.profile = void 0;
    _this.watchLater = void 0;
    _this.communityApi = void 0;
    _this.facebookApi = void 0;
    _this.interests = void 0;
    _this.pointSystemApi = void 0;
    _this.likes = new MeLikesApi(config);
    _this.notifications = new MeNotificationsApi(config);
    _this.playlists = new MePlaylistsApi(config);
    _this.profile = new MeProfileApi(config);
    _this.watchLater = new MeWatchLaterApi(config);
    _this.communityApi = new MeCommunityApi(config);
    _this.facebookApi = new MeFacebookApi(config);
    _this.interests = new MeInterestsApi(config);
    _this.pointSystemApi = new MePointSystemApi(config);
    return _this;
  }

  return MeApi;
}(BaseApi);

/**
 * TEMP not needed if using identity. send email verification to user's existing email address.
 */
MeApi.prototype.sendEmailVerification = makeDataMethod({
  method: 'post',
  path: Request.Me.Paths.SendEmailVerification,
  needAuth: true
});
/**
 * sync app actions to server
 */

MeApi.prototype.sync = makeDataMethod({
  method: 'post',
  path: Request.Me.Paths.Sync,
  needAuth: true
});
/**
 * curation week for user based on time
 */

MeApi.prototype.getRecommended = makeMethod({
  method: 'get',
  path: Request.Me.Paths.GetRecommended,
  needAuth: true
});
/**
 * list user subscriptions
 */

MeApi.prototype.listSubscriptions = makeMethod({
  method: 'get',
  path: Request.Me.Paths.ListSubscriptions,
  needAuth: true
});
/**
 * list of videos watched by user, ordered by last date watched
 */

MeApi.prototype.listWatchHistory = makeMethod({
  method: 'get',
  path: Request.Me.Paths.ListWatchHistory,
  needAuth: true
});